<nav class="wizard" [attr.aria-label]="i18n.A11y_WizardNavType">
  <!--Open wizard (mobile only)-->

  <!-- <df-icon icon="home" size="medium" class="wizard__step--completed"></df-icon> -->
  <div
    *ngIf="isMobile && !mobileOpen"
    class="wizard__step wizard__step--current wizard__step--mobile"
    [ngStyle]="{ 'counter-reset': 'wiz-counter ' + mobileActiveStep.id }"
  >
    <button
      type="button"
      (click)="openMobile()"
      class="h3 wizard__step--mobile-button"
      [attr.aria-label]="i18n.A11y_WizardClickExpand"
      data-dgat="wizard-710"
    >
      {{ mobileActiveStep.label
      }}<df-icon icon="chevron-down" size="small"></df-icon>
    </button>
  </div>

  <!--Close wizard (mobile only)-->
  <button
    *ngIf="isMobile && mobileOpen"
    aria-label="collapse"
    class="h3 wizard__mobile-collapse"
    (click)="closeMobile()"
    data-dgat="wizard-aa9"
  >
    <df-icon icon="chevron-up" size="medium"></df-icon>
  </button>

  <!--Steps-->
  <ol *ngIf="!isMobile || mobileOpen" class="wizard__steps">
    <li
      *ngFor="let step of steps"
      class="wizard__step"
      data-dgat="wizard-12c"
      [ngClass]="{
        'wizard__step--clickable': step.isClickable,
        'wizard__step--current': step.isCurrent,
        'wizard__step--completed': step.isCompleted,
        'wizard__step--single': steps.length === 1,
        'wizard__step--active': step.isActive
      }"
    >
      <df-icon icon="checkmark" *ngIf="step.isCompleted" size="small"></df-icon>
      <!--Step label-->
      <div *ngIf="steps.length > 1 && step.label">
        <button
          *ngIf="step.isClickable"
          class="h3 wizard__step-heading"
          data-dgat="wizard-e8d"
          [textContent]="step.label"
          [attr.aria-current]="step.isCurrent ? 'step' : undefined"
          (click)="onClick($event, step)"
        ></button>
        <span
          *ngIf="!step.isClickable"
          class="h3 wizard__step-heading"
          [textContent]="step.label"
        ></span>
      </div>

      <!--Step Description-->
      <div
        *ngIf="steps.length > 1 && step.description"
        class="par par--small par--light wizard__step-description"
        [textContent]="step.description"
      ></div>

      <!--Tasks-->
      <ol *ngIf="step.isExpanded" class="wizard__tasks">
        <li
          *ngFor="let task of step.tasks"
          class="wizard__task par par--small font-semibold"
          data-dgat="wizard-5e5"
          [ngClass]="{
            'wizard__task--clickable': task.isClickable,
            'wizard__task--completed': task.isCompleted,
            'wizard__task--current': task.isCurrent,
            'wizard__task--active': task.isActive
          }"
        >
          <!--Task label-->
          <button
            *ngIf="task.isClickable"
            class="wizard__task-link"
            data-dgat="wizard-416"
            [textContent]="task.label"
            [attr.aria-current]="task.isCurrent ? 'step' : undefined"
            (click)="onClick($event, task)"
          ></button>
          <span
            *ngIf="!task.isClickable"
            class="wizard__task-link"
            [textContent]="task.label"
          ></span>
        </li>
      </ol>
      <!--/Tasks-->
    </li>
  </ol>
  <!--/Steps-->
</nav>
